import React from 'react';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';

export const useAlert = () => {
  const { message, variant, key, onUpdate } = useSelector<any, any>(({ alert }) => alert);
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (onUpdate) {
      enqueueSnackbar(message, { variant, key });
    }
  }, [enqueueSnackbar, message, variant, key, onUpdate]);
};
